import React, { useEffect, useState } from 'react';
import HeaderInfo from '../HeaderInfo/HeaderInfo';
import styles from './OptionsPricing.module.scss';
import NextButton from '../NextButton/NextButton';
import { Grid } from '@mui/material';
import BackButton from '../BackButton/BackButton';
import { connect } from 'react-redux';
import { openModal } from '../../../redux/modals/action';
import {
	getAgreementDataById,
	nextActiveStep,
	saveAgreementInfo,
} from '../../../redux/agreement/actions';
import { useParams } from 'react-router';
import OptionContent from './OptionContent/OptionContent';
import setLotToAvailable from '../../../api/Agreement/setLotToAvailable.api';
import removeDepositSchedule from '../../../api/Agreement/removeDepositSchedule.api';
import { setAlert } from '../../../redux/alerts/action';
import _ from 'lodash';

const OptionsPricing = ({
	openModal,
	saveAgreementInfo,
	loadedData,
	totalOptions,
	clientInfo,
	getAgreementDataById,
	productAvailability,
	setAlert,
	nextActiveStep,
}) => {
	const [optionCheck, setOptionCheck] = useState(
		loadedData ? loadedData : {}
	);

	const [totalOptionPrice, setTotalOptionPrice] = useState(0);
	const params = useParams();
	useEffect(() => {
		var optionCheckKeys = optionCheck && Object.keys(optionCheck);
		if (optionCheckKeys && optionCheckKeys.length > 0) {
			var priceArr = [];

			optionCheckKeys.forEach((key) => {
				var price = parseInt(optionCheck[key]['value']);

				priceArr.push(price);
			});

			setTotalOptionPrice(priceArr?.reduce((a, b) => a + b, 0));
		} else {
			setTotalOptionPrice(0);
		}
	}, []);
	const handleNext = () => {
		if (Number(totalOptionPrice) !== Number(totalOptions)) {
			// clear previous deposit schedule when user change options
			removeDepositSchedule(params.id);
		}
		let userVerifedArr = _.map(clientInfo?.individual, function (el) {
			let verification = el?.identification?.verification?.status;
			return (
				verification === 'verified' ||
				verification === 'manually_verified'
			);
		});

		if (userVerifedArr?.every((el) => el === true)) {
			// openModal('reviewAps');
			getAgreementDataById(params.id);
			handleSaveAndExit();
			setTimeout(() => {
				openModal('reviewAps');
			}, 1000);
		} else {
			setAlert(
				'warning',
				'User not verified, please verify user to create the agreement.'
			);
		}

		nextActiveStep();

		////
		// optionCheck &&
		//  Object.keys(optionCheck).length !== 0 &&
		//  (await saveAgreementInfo(params.id, 'options', optionCheck));

		// if (Object.keys(optionCheck).length === 0) {
		//  await saveAgreementInfo(params.id, 'options', optionCheck);
		// }

		// setTimeout(async () => {
		//  totalOptionPrice &&
		//      (await saveAgreementInfo(
		//          params.id,
		//          'totalOptions',
		//          totalOptionPrice
		//      ));
		//  if (totalOptionPrice === 0) {
		//      saveAgreementInfo(params.id, 'totalOptions', '0');
		//  }
		// }, 300);
	};

	const handleSaveAndExit = async () => {
		optionCheck &&
			Object.keys(optionCheck).length !== 0 &&
			(await saveAgreementInfo(params.id, 'options', optionCheck));

		if (Object.keys(optionCheck).length === 0) {
			await saveAgreementInfo(params.id, 'options', optionCheck);
		}

		setTimeout(async () => {
			totalOptionPrice &&
				(await saveAgreementInfo(
					params.id,
					'totalOptions',
					totalOptionPrice
				));
			if (totalOptionPrice === 0) {
				saveAgreementInfo(params.id, 'totalOptions', '0');
			}
		}, 300);
	};

	const handleBackToProductAvailability = () => {
		if (productAvailability?.lotId) {
			setLotToAvailable(productAvailability?.lotId);
			saveAgreementInfo(params.id, 'productAvailability', {});
		}
	};

	return (
		<div className={styles.optionsPricingWrapper}>
			<HeaderInfo
				title={'Options & Pricing'}
				onSaveAndExit={handleSaveAndExit}
			/>

			<OptionContent
				optionCheck={optionCheck}
				setOptionCheck={setOptionCheck}
				totalOptionPrice={totalOptionPrice}
				setTotalOptionPrice={setTotalOptionPrice}
			/>

			<Grid container justifyContent='space-between'>
				<Grid item className={styles.backButtonWrapper}>
					<div onClick={handleBackToProductAvailability}>
						<BackButton delay />
					</div>
				</Grid>
				<Grid
					item
					className={styles.nextButtonWrapper}
					onClick={() => handleNext()}
				>
					<NextButton />
				</Grid>
			</Grid>
		</div>
	);
};

const mapStateToProps = (state) => ({
	loadedData: state.agreement?.agreementById?.options,
	productAvailability: state.agreement?.agreementById?.productAvailability,
	clientInfo: state.agreement?.agreementById?.clientInfo,
	totalOptions: state.agreement?.agreementById?.totalOptions,
});

export default connect(mapStateToProps, {
	openModal,
	saveAgreementInfo,
	getAgreementDataById,
	setAlert,
	nextActiveStep,
})(OptionsPricing);
